/* eslint-disable import/prefer-default-export */
import {
  apiGetSuppliers,
  apiGetProductCategories,
  apiGetFactoryList,
  apiGetBuyerList,
  apiAddProduct,
  apiCreateSupplier,
  apiUpdateProduct,
  apiGetCountryList,
} from 'api';
import addProductTypes from './types';
import { apiUpdateSupplier } from '../../api/add-product';

// GET_SUPPLIERS
export const getSupplierList = (cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.GET_SUPPLIERS,
    asyncCall: () => {
      return apiGetSuppliers();
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_PRODUCT_CATEGORIES
export const getProductCategories = (filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.GET_PRODUCT_CATEGORIES,
    asyncCall: () => {
      return apiGetProductCategories(filters);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_FACTORY_LIST
export const getFactoryList = (id, filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.GET_FACTORY_LIST,
    asyncCall: () => {
      return apiGetFactoryList(id, filters);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_BUYER_LIST
export const getBuyerList = (id, filters = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.GET_BUYER_LIST,
    asyncCall: () => {
      return apiGetBuyerList(id, filters);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// ADD_PRODUCT
export const addProduct = (data = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.ADD_PRODUCT,
    asyncCall: () => {
      return apiAddProduct(data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// UPDATE_PRODUCT
export const updateProduct = (id, data = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.UPDATE_PRODUCT,
    asyncCall: () => {
      return apiUpdateProduct(id, data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// CREATE_SUPPLIER
export const createSupplier = (data = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.CREATE_SUPPLIER,
    asyncCall: () => {
      return apiCreateSupplier(data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// UPDATE_SUPPLIER
export const updateSupplier = (id, data = {}, cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.UPDATE_SUPPLIER,
    asyncCall: () => {
      return apiUpdateSupplier(id, data);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
// GET_COUNTRY_LIST
export const getV2CountryList = (cb) => {
  return {
    isAsyncCall: true,
    baseType: addProductTypes.GET_COUNTRY_LIST,
    asyncCall: () => {
      return apiGetCountryList();
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
